export default __webpack_public_path__ + "static/media/self checkout.39bd337e.svg";